import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import RangeValueItem from 'trade-in/components/CanadianBlackBookEstimate/components/RangeValueItem.jsx';

import './RangeValue.scss';

const czGroup = 'widget.tradein.teaser';

const RangeValue = ({ high, low }) => {
    const defaultHighValueCz = '#1DD1A1';
    const defaultLowValueCz = '#EB3B5A';
    const highValueCz = ContentZonesService.getContentZone(czGroup, 'estimate.value.high.color');
    const lowValueCz = ContentZonesService.getContentZone(czGroup, 'estimate.value.low.color');
    return (
        <div className="range-value_wrapper">
            <RangeValueItem
                backgroundColor={lowValueCz ? lowValueCz.getValue() : defaultLowValueCz}
                classesName={['low_value']}
                description={LocaleService.t('TRADE_IN.ESTIMATE.VALUE.LOW.DESCRIPTION')}
                title={LocaleService.t('TRADE_IN.ESTIMATE.VALUE.LOW.TITLE')}
                value={low}
                dataTest="trade-in.range-value.low-value"
            />
            <RangeValueItem
                backgroundColor={highValueCz ? highValueCz.getValue() : defaultHighValueCz}
                classesName={['high_value']}
                description={LocaleService.t('TRADE_IN.ESTIMATE.VALUE.HIGH.DESCRIPTION')}
                title={LocaleService.t('TRADE_IN.ESTIMATE.VALUE.HIGH.TITLE')}
                value={high}
                dataTest="trade-in.range-value.high-value"
            />
        </div>
    );
};

RangeValue.displayName = 'RangeValue';

RangeValue.propTypes = {
    high: PropTypes.number.isRequired,
    low: PropTypes.number.isRequired,
};

export default RangeValue;



// WEBPACK FOOTER //
// ./src/components/CanadianBlackBookEstimate/components/RangeValue.jsx